import React from "react";
import { AppRouter } from "./routes";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
      <AppRouter></AppRouter>
  );
}

export default App;
